/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatPhoneNumber } from 'react-phone-number-input';
import PageNotFound from '../../../components/PageNotFound';
import AlertMessage from '../../../components/AlertMessage';
import Loading from '../../../components/Loading';
import PageLayout from '../../shared/PageLayout';
import { PageContext } from '../context';
import UserInfoCheckin from './UserInfo';
import CheckInConfirm from './CheckInConfirm';

const QRItem = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [isCompleted, setCompleted] = useState(false);

  const [alertData, setAlertData] = useState({
    open: false,
    handleClose: () => false,
    variant: 'error',
    message: '',
    duration: 3000,
  });

  const {
    loadUserInfo,
    eventUserLoading,
    eventUserError,
    eventUserData,
    handleCheckin,
  } = useContext(PageContext);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAlertData({ ...alertData, open: false });
  };

  const showSuccess = (message) => {
    const newData = {
      ...alertData,
      open: true,
      variant: 'success',
      message,
      handleClose,
    };
    setAlertData(newData);
  };

  const showError = (error) => {
    const newData = {
      ...alertData,
      open: true,
      variant: 'error',
      message: error,
      handleClose,
    };
    setAlertData(newData);
  };

  useEffect(() => {
    loadUserInfo(userId);
  }, [userId]);

  const message = eventUserError && eventUserError.message;
  useEffect(() => {
    if (message) {
      showError(message);
      setUser(null);
    }
  }, [message]);

  const userData = JSON.stringify(eventUserData);
  useEffect(() => {
    const hasData = eventUserData && eventUserData.node;
    const hasAttendee = hasData && hasData.attendee;

    if (hasAttendee) {
      const {
        node: {
          attendee: {
            firstName,
            lastName,
            primaryPhoneNumber: {
              number,
            },
          },
          status,
        },
      } = eventUserData;

      const newUser = {
        firstName,
        lastName,
        phoneNumber: formatPhoneNumber(number),
        status,
        onCheckin: () => handleCheckin(userId, {
          onSuccess: () => {
            showSuccess('Sucessfully checked in');
            setCompleted(true);
          },
          onError: (error) => showError(error),
        }),
      };

      setUser(newUser);
    }
  }, [userData]);

  return (
    <PageLayout isDark>
      {eventUserLoading && <Loading />}

      {!isCompleted && user && <UserInfoCheckin user={user} />}
      {isCompleted && <CheckInConfirm />}

      <AlertMessage {...alertData} />
    </PageLayout>
  );
};

export default QRItem;
